// extracted by mini-css-extract-plugin
module.exports = {"titleBlock":"styles_titleBlock__nE6Bp","subtitle":"styles_subtitle__heEzW","title":"styles_title__wrTcV"};